import React from "react"
import styled from "styled-components"
import Collapse from "@material-ui/core/Collapse"
import Typography from "../../../Typography"
import { DownChevron } from "../../../Icons"
import { LinkH400 } from "../../../NormalLink"
import { Location } from "../../../../styles/sharedStyles"

const { H400 } = Typography

const ItemWithSubItems = styled.div`
  ${H400}
  padding: 16px;
  text-align: center;
  display: block;
  color: ${(props) => props.theme.colors.black900};
`

const ItemChild = styled(LinkH400)`
  padding: 16px;
  text-align: center;
  display: block;
  color: ${(props) => props.theme.colors.black700};
`

const DownChevronSpacing = styled.div`
  display: inline-block;
  padding-left: 16px;
`

const LocationStyled = styled(Location)`
  justify-content: center;
`

class MobileNavSubItems extends React.PureComponent {
  state = {
    open: false,
  }

  handleClick() {
    const { open } = this.state
    this.setState({
      open: !open,
    })
  }

  render() {
    const { open } = this.state
    const { items, title, onClick } = this.props
    return (
      <>
        <ItemWithSubItems onClick={() => this.handleClick()}>
          {title}
          <DownChevronSpacing>
            <DownChevron width="12px" height="12px" margin="0" flip={open} />
          </DownChevronSpacing>
        </ItemWithSubItems>
        {items.map((item) => {
          return (
            <Collapse in={open} key={`${item.title}-collapse`}>
              <ItemChild to={item.internalLink} onClick={() => onClick()}>
                {(item.flag && item.title) && (
                  <LocationStyled>
                    {item.flag && (
                      <img
                        src={`${item.flag.asset.url}?w=24`}
                        style={{
                          marginRight: "12px",
                          maxWidth: "24px",
                        }}
                        alt={item.title || "Country"}
                      />
                    )}

                    <p>{item.title}</p>
                  </LocationStyled>
                )}
                {!item.flag && item.title && <p>{item.title}</p>}
              </ItemChild>
            </Collapse>
          )
        })}
      </>
    )
  }
}

export default MobileNavSubItems
